import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import indiaStates from '../../../../../../../assets/js/india.state.list.json';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { CommonServices } from 'src/app/Services/common.service';
import { LoaderService } from 'src/app/Services/loader.service';

export interface User {
  name: string;
}
@Component({
  selector: 'app-edit-escort',
  templateUrl: './edit-escort.component.html',
  styleUrls: ['./edit-escort.component.css']
})

export class EditEscortComponent implements OnInit {

  matFormSize = '13px'
  editEmployeeForm: FormGroup;

  isShowSimno = false;
  isShowVendorName = false;
  selectState = ''
  selection = ''
  myControl = new FormControl();
  public stateSelect = indiaStates.IND;
  options: User[] = [];
  filteredOptions: Observable<User[]>;
  isShowImg: boolean = false
  strDate: any;

  purchDate: any;
  rcStrDate: any;
  shiftArr: any[] = []
  public stateData = []
  submitted = false;

  // public stateSelect = indiaStates.IND;

  public editLocation: boolean = true;
  public employeeLocation = {};
  public locationData = {};

  minFromDate = new Date();
  maxToDate = new Date().setDate(2);
  //VendorInfos: any;
  shiftInformation: any = [];
  branchInformation: any[];
  public orgID;
  public escortID;
  public profileImage: any;
  public branchUpdate: boolean = false;

  public updateValues = [];
  public isLocMandatory: boolean = false;
  formSubmit: boolean = false;

  get frm() {
    return this.editEmployeeForm.controls;
  }

  constructor(
    public fb: FormBuilder,
    public api: ApiService,
    public route: ActivatedRoute,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,
    public file: FileUploadService,
    public comService: CommonServices,
    public loader: LoaderService
  ) {
    this.orgID = this.storage.get('userInfo').orgID;
    this.route.paramMap.subscribe((params: any) => {
      this.escortID = params.params.escortID;
    });
  }

  ngOnInit(): void {

    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.options.slice())
      );
    this.getBranchList();
    this.getStateOptions();
    this.getListShift();
    this.addFormLoad();
    setTimeout(() => this.getEmployeeData(), 500);

  }

  displayFn(user: User): string {
    this.stateData = []
    this.stateData.push(user)
    // this.editEmployeeForm.value.patchValue({state:user}
    return user && user.name ? user.name : '';
  }

  private _filter(name: string): User[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  getBranchList() {
    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        if (res.data && res.data.length > 0) {
          this.branchInformation = [];
          res.data.filter((e) => {
            let option = { name: e.branchName, value: e.branchID };
            this.branchInformation.push(option);
          });
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  getListShift() {
    const obj = {
      orgID: this.orgID
    };
    this.api.ListShift(obj).then((res: any) => {
      if (res.status == 'success') {
        this.shiftInformation = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  onChangeBrach(val) {
    // console.log(val, this.shiftInformation)
    this.shiftArr = []
    this.shiftInformation.forEach((element, i) => {
      // console.log(element.branch == val)
      if (element.branch == val) {
        this.shiftArr.push(element)
      }
    });
    if (this.branchUpdate) this.fieldChange(val, 'branch', 'branch');
    // console.log(this.shiftArr)
  }
  getStateOptions() {
    this.stateSelect.forEach(element => {
      // console.log(element)
      this.options.push({ name: element })
    });
  }

  addFormLoad() {

    this.editEmployeeForm = this.fb.group({
      name: ['', Validators.compose([Validators.required, Validators.pattern('^([^0-9@#$%&*]*)$')])],
      empRefID: [''],
      email: ['', Validators.compose([Validators.email])],
      dob: [''],
      gender: [''],
      mobile: ['', Validators.compose([Validators.required, Validators.pattern('[0-9]\\d{9}')])],
      emergencyContact: ['', Validators.compose([Validators.pattern('[0-9]\\d{9}')])],
      bloodGroup: [''],
      address: [''],
      city: [''],
      state: [''],
      country: [{ value: 'India', disabled: true }],
      pincode: ['', Validators.compose([Validators.pattern('[0-9]\\d{5}')])],
      department: ['', Validators.compose([Validators.required])],
      workLocation: [''],
      branch: [''],
      shift: [''],
      location: [''],
      profilePic: ['']
    });
  }
  public checkError = (controlName: string, errorName: string) => {
    return this.editEmployeeForm.controls[controlName].hasError(errorName);
  }
  getEmployeeData() {
    const obj = {
      orgID: this.orgID,
      escortID: this.escortID
    };
    this.api.transportManagerEscortList(obj).then((res: any) => {
      if (res.status == 'success') {
        const data = res.data[0];
        this.setValueEditEmployeeForm(data);
        this.selection = data.gender
        //this.profileImage = data.profile
        // this.selectState = data.state
        this.myControl.setValue(data.state);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  setValueEditEmployeeForm(data) {
    this.editEmployeeForm.patchValue({
      name: data?.name || '',
      empRefID: data?.empRefID || '',
      email: data?.email || '',
      dob: data?.dob ? new Date(data.dob) : '',
      gender: data?.gender ? this.comService.convertTitleCase(data.gender) : '',
      mobile: data?.mobile || '',
      emergencyContact: data?.emergencyContact || '',
      bloodGroup: data?.bloodGroup ? String(data.bloodGroup).toLowerCase() : '',
      address: data?.address || '',
      city: data?.city || '',
      state: data?.state || '',
      // country: data?.country || '',
      pincode: data?.pincode || '',
      department: data?.department || '',
      workLocation: data?.workLocation || '',
      branch: data?.branch || '',
      shift: data?.shift || '',
      location: data?.location ? data.location.name || '' : '',
      profilePic: data?.profilePic || '',
    });

    if (data['profilePic']) this.profileImage = `${data['profilePic']}?time=${Date.now()}`;

    this.locationData = { ...data.location };
    this.employeeLocation = data.location;
    // this.profileImage = data.profile;
    this.onChangeBrach(data.branch);
    this.branchUpdate = true;
  }

  getLocation(obj) {
    this.employeeLocation = { ...obj };
    this.fieldChange(this.employeeLocation, 'location', 'location');
  }

  // async handleUpload(event) {
  //   let base64;
  //   this.profileImage = await this.file.fileHandeleBase64(event);
  //   this.editEmployeeForm.controls.profile.patchValue(this.profileImage);
  //   this.fieldChange(this.profileImage, 'file', 'profile');
  //   this.profileImage = await this.file.fileHandeleBase64(event);
  //   base64 = this.profileImage;
  // }

  /* update unique field*/
  fieldChange(e: any, type, field) {
    if (type == 'text' || type == 'textarea') {
      let value = e.target.value;
      if (field == 'email' && value != '') value = value.toLowerCase();
      if ((field == 'mobile' || field == 'emergencyContact' || field == 'pincode') && value != '') value = parseInt(value);
      this.updateField(field, value);
    }
    if (type == 'date' || type == 'dropdown' || type == 'radio') {
      let value = e.value;
      if (type == 'date') value = e.value.getTime();
      this.updateField(field, value);
    }
    if (type == 'location' || type == 'file' || type == 'branch') {
      this.updateField(field, e);
    }
  }
  updateField(field, value) {
    if (this.updateValues.length > 0) {
      let filterUpdate = this.updateValues.filter((e) => e.field != field);
      let obj = { field: field, value: value, };
      this.updateValues = [
        ...filterUpdate,
        obj,
      ]
    }
    else {
      let obj = { field: field, value: value, };
      this.updateValues.push(obj);
    }
  }


  async handleUpload(event) {
    // const file = (event.target as HTMLInputElement).files?.[0]
    const file = event.target.files[0];
    const maxFileSizeInMB = 1;
    const maxFileSize = maxFileSizeInMB * 1024 * 1024;
    const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

    if (!file) return;
    const isValid = this.validateFile(file, allowedImageTypes, maxFileSize);
    if (!isValid) return;

    this.profileImage = await this.file.fileHandeleBase64(event);
    this.fieldChange(file, 'file', 'profilePic');
    this.editEmployeeForm.controls.profilePic.patchValue(file);
  }
  validateFile(file, allowedImageTypes, maxFileSize) {
    if (!allowedImageTypes.includes(file.type)) {
      return this.showErrorMessage('Invalid file type. Only images are allowed.');
    }
    if (file.size > maxFileSize) {
      return this.showErrorMessage(`File size exceeds 1 MB`);
    }
    return true;
  }

  reUpload(field) {
    document.getElementById(field).click();
  }

  cancelImage() {
    this.profileImage = undefined;
    this.editEmployeeForm.controls.profilePic.patchValue('');
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();

    }
  }
  onChangeBoxType(e) {
    this.isShowVendorName = false;
    this.isShowSimno = false;
    if (e.value == 'others') { this.isShowVendorName = true; }
    if (e.value == 'group10') { this.isShowSimno = true; }
  }
  private showErrorMessage(message: string) {
    this.swal.swalFunction('error', 'error', message, 5000);
  }

  onSubmit() {
    // this.formSubmit = true;
    this.submitted = true;
    if (this.editEmployeeForm.valid && this.updateValues && this.updateValues.length > 0) {

      const obj = {
        // orgID: this.orgID,
        escortID: this.escortID,
        profileType: 'Image'
      };

      this.updateValues.filter((e) => {
        obj[e.field] = e.value;
      });
      if (this.profileImage == '' || (obj['profilePic'] == '')) { delete obj['profile']; delete obj['profileType']; }
      else {
        obj.profileType = 'Image';
      }

      let url = 'organization/escort/update';
      this.api.transportManagerFormDataCreate(obj, url, (res: any) => {
        if (res['responseJSON']['status'] == 'success') {
          this.swal.swalFunction(res['responseJSON'].status, res['responseJSON'].status, res['responseJSON'].message, 2000);
          this.router.navigate(['/organization/transport-manager/information/orgInfo/escort/view-escort'])
        }
        if (res['responseJSON'].status == 'failure') {
          this.loader.hide();
          this.swal.swalFunction('error', res['responseJSON'].status, res['responseJSON'].message, 3000);
        }
      })

    } else {
      this.comService.markFormGroupTouched(this.editEmployeeForm)
    }
  }
}

